import { render, staticRenderFns } from "./UserActivities.vue?vue&type=template&id=5704d6ad&"
import script from "./UserActivities.controller.js?vue&type=script&lang=js&"
export * from "./UserActivities.controller.js?vue&type=script&lang=js&"
import style0 from "./UserActivities.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports